console.log('offer-selector.js active')

const variantOfferSelectors = document.querySelectorAll('.variant-selector .variant-item');
variantOfferSelectors.forEach(selector => {
  selector.addEventListener('click', function() {

    const variantIndex = selector.getAttribute('data-index');
    const index = parseInt(variantIndex) - 1;

    document.querySelectorAll('.variant-item.active').forEach(el => {
      el.classList.remove('active');
    })

    document.querySelectorAll(`.variant-item[data-index="${variantIndex}"]`).forEach(el => {
      el.classList.add('active');
    })
    
    const myArray = JSON.parse(document.querySelector('#offer_variants').textContent);

    const selectedVariant = myArray[index];

    setVariantImage(selectedVariant.image);
    setGifts(selectedVariant.amount_of_gifts);
    setVariantId(selectedVariant.id);
    setPrice(selectedVariant.old_price, selectedVariant.new_price);
    setKlarnaPrice(selectedVariant.klarna_price);
    setSavePrice(selectedVariant.save_percentage ? selectedVariant.save_percentage : null);
    // setSavePercentage(selectedVariant.save_percentage ? selectedVariant.save_percentage : null);
    setShipping(selectedVariant.free_shipping);
  })
})

window.addEventListener('load', function() {
  const myArray = JSON.parse(document.querySelector('#offer_variants').textContent);

  setTotalAmountOfGifts(myArray[0].amount_of_gifts);

  variantOfferSelectors[0].click();

  const atcButtons = document.querySelectorAll('.atc-button');
  atcButtons.forEach(button => {
    button.addEventListener('click', function() {
      button.innerHTML = `Toevoegen...`;

      setTimeout(() => {
        button.innerHTML = `Bestel nu`;
      }, 4000)
    })
  })
})

function setPrice(oldPrice, newPrice) {
  document.querySelectorAll('.card-price .old-price').forEach(el => {
    el.innerHTML = oldPrice;
  })
  document.querySelectorAll('.card-price .new-price').forEach(el => {
    el.innerHTML = newPrice;
  })
}

function setTotalAmountOfGifts(amount) {
  document.querySelectorAll('.total_amount_of_gifts').forEach(el => {
    el.innerHTML = amount;
  })
  document.querySelectorAll('.amount_of_gifts_unlocked').forEach(el => {
    el.innerHTML = amount;
  })
}

function setKlarnaPrice(price) {
  const priceContainers = document.querySelectorAll('.offer-selector .klarna__badge-container .klarna-price');
  priceContainers.forEach(el => {
    el.innerHTML = price;
  })
}

function setShipping(shipping) {
  if (shipping) {
    document.querySelectorAll('[data-shipping="true"]').forEach(el => {
      el.style.display = 'flex';
    })
    document.querySelectorAll('[data-shipping="false"]').forEach(el => {
      el.style.display = 'none';
    })
  } else {
    document.querySelectorAll('[data-shipping="true"]').forEach(el => {
      el.style.display = 'none';
    })
    document.querySelectorAll('[data-shipping="false"]').forEach(el => {
      el.style.display = 'flex';
    })
  }
}

function setSavePrice(price) {

  const offerSelectors = document.querySelectorAll('.offer-selector');

  offerSelectors.forEach(selector => {
    const priceContainer = selector.querySelector('.save_price');
  
    if (price) {
      priceContainer.innerHTML = price;
      selector.querySelector('.save-text').style.opacity = '1';
    } else {
      selector.querySelector('.save-text').style.opacity = '0';
    }

    console.log('label', document.querySelector('.pdp-label'))
    if (document.querySelector('.pdp-label')) {
      document.querySelector('.pdp-label span').innerHTML = `${price}% korting`;
    }
  });
}

function setSavePercentage(percentage) {
  console.log('set perc');

  const offerSelectors = document.querySelectorAll('.offer-selector');

  offerSelectors.forEach(selector => {
    const priceContainer = selector.querySelector('.save_price');
  
    if (percentage) {
      priceContainer.innerHTML = percentage + '%';
      selector.querySelector('.save-text').style.opacity = '1';
    } else {
      selector.querySelector('.save-text').style.opacity = '0';
    }
  });
}

function setVariantImage(url) {
  const variantImages = document.querySelectorAll('.variant-image');
  variantImages.forEach(image => {
    image.src = url;
  })
}

function setVariantId(id) {
  const variantInputs = document.querySelectorAll('[data-offer="gifts"] [name="id"]');
  variantInputs.forEach(el => {
    el.value = id;
  });
}

function setGifts(amount) {
  const offerSelectors = document.querySelectorAll('.offer-selector');

  offerSelectors.forEach(selector => {
    const giftItems = selector.querySelectorAll('.gifts .gift-item');
  
    giftItems.forEach(gift => {
      gift.classList.remove('unlocked');
    })
  
    let amountUnlocked = 0;

    for (let i = 0; i < amount; i++) {
      if (amount == 1) {
        giftItems[0].classList.add('unlocked');
        amountUnlocked = 1;
      } else {
        giftItems[i + 0].classList.add('unlocked');
        amountUnlocked++
      }
    } 
  
    selector.querySelector('.amount_of_gifts_unlocked').innerHTML = amountUnlocked;
  
    const giftIcon = selector.querySelector('.gifts_icon');
    giftIcon.innerHTML = amountUnlocked > 0 ? '🔓' : '🔒'
  
    const giftsLock = selector.querySelector('.gifts-lock');
    giftsLock.style.opacity = amountUnlocked > 0 ? '1' : '0.5'
  })
}



document.addEventListener('DOMContentLoaded', function() {
  function setupGallery(galleryElement) {
    const mainImage = galleryElement.querySelector('.main-image');
    const thumbnails = galleryElement.querySelectorAll('.thumbnail');

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        // Update main image
        mainImage.src = this.src;
        
        // Update active state
        thumbnails.forEach(thumb => thumb.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }

  // Setup desktop gallery
  const desktopGallery = document.querySelector('.image-gallery.desktop');
  if (desktopGallery) {
    setupGallery(desktopGallery);
  }

  // Setup mobile gallery
  const mobileGallery = document.querySelector('.image-gallery.mobile');
  if (mobileGallery) {
    setupGallery(mobileGallery);
  }
});